// extracted by mini-css-extract-plugin
export var activeLink = "navigation-module--activeLink--aLg76";
export var navLink = "navigation-module--navLink--xLalQ";
export var navStyle = "navigation-module--navStyle--jnzTx";